export function gameplayerUpdateLoadProgress(progress, text) {
    return { type: 'GAMEPLAYER_LOADING_UPDATE_PROGRESS', payload: { progress, text } };
}

export function gameplayerSetLoadingComplete(complete) {
    return { type: 'GAMEPLAYER_LOADING_SET_COMPLETE', payload: complete};
}